import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let companyIndex = () => import(/* webpackChunkName: "company" */ '@/views/company/Index');
let companyCreate = () => import(/* webpackChunkName: "company" */ '@/views/company/Create');
let companyEdit = () => import(/* webpackChunkName: "company" */ '@/views/company/Edit');
let groupIndex = () => import(/* webpackChunkName: "group" */ '@/views/company/group/Index');
let placeIndex = () => import(/* webpackChunkName: "place" */ '@/views/company/place/Index');
let filedIndex = () => import(/* webpackChunkName: "field" */ '@/views/company/field/Index');
let projectIndex = () => import(/* webpackChunkName: "project" */ '@/views/company/project/Index');
let projectEdit = () => import(/* webpackChunkName: "project" */ '@/views/company/project/Edit');
let projectCreate = () => import(/* webpackChunkName: "project" */ '@/views/company/project/Create');
let companyService = () => import(/* webpackChunkName: "service" */ '@/views/company/service/Index');
let companyContact = () => import(/* webpackChunkName: "contact" */ '@/views/company/contact/Index');
let companyCatalog = () => import(/* webpackChunkName: "catalog" */ '@/views/company/catalog/Index');
let companyCertificate = () => import(/* webpackChunkName: "certificate" */ '@/views/company/certificate/Index');
let newsIndex = () => import(/* webpackChunkName: "project" */ '@/views/company/news/Index');
let newsEdit = () => import(/* webpackChunkName: "project" */ '@/views/company/news/Edit');
let newsCreate = () => import(/* webpackChunkName: "project" */ '@/views/company/news/Create');
let panelIndex = () => import(/* webpackChunkName: "project" */ '@/views/company/panel/Index');
 export default [
    ...prefix("company",[
        {
            path: "list",
            name: "company.index",
            component: companyIndex,
            meta: {
                middleware: web,
                permissions: ['companies:viewAny'],
                title: "شرکت ها"
            }
        },
        {
            path: "list/:id",
            name: "company.edit",
            component: companyEdit,
            meta: {
                middleware: web,
                permissions: ['companies:view','companies:update'],
                title: "جزئیات شرکت"
            }
        },
        {
            path: "create",
            name: "company.create",
            component: companyCreate,
            meta: {
                middleware: web,
                permissions: ['companies:create'],
                title: "ایجاد شرکت"
            }
        },
        {
            path: "list/:id/projects",
            name: "company.projects",
            component: projectIndex,
            meta: {
                middleware: web,
                permissions: ['company-projects:viewAny'],
                title: "پروژه های شرکت"
            }
        },
        {
            path: "list/:id/contacts",
            name: "company.contacts",
            component: companyContact,
            meta: {
                middleware: web,
                permissions: ['company-contacts:viewAny'],
                title: "اطلاعات تماس شرکت"
            }
        },
        {
            path: "list/:id/services",
            name: "company.services",
            component: companyService,
            meta: {
                middleware: web,
                permissions: ['company-services:viewAny'],
                title: "خدمات شرکت"
            }
        },
        {
            path: "list/:id/catalogs",
            name: "company.catalogs",
            component: companyCatalog,
            meta: {
                middleware: web,
                permissions: ['company-catalogs:viewAny'],
                title: "کاتالوگ شرکت"
            }
        },
        {
            path: "list/:id/certificates",
            name: "company.certificate",
            component: companyCertificate,
            meta: {
                middleware: web,
                permissions: ['company-certificates:viewAny'],
                title: "گواهینامه شرکت"
            }
        },
        {
            path: "list/projects/:id",
            name: "company.project.edit",
            component: projectEdit,
            meta: {
                middleware: web,
                permissions: ['company-projects:update','company-projects:view'],
                title: " جزئیات پروژه ها"
            }
        },
        {
            path: "list/:id/project/create",
            name: "company.projects.create",
            component: projectCreate,
            meta: {
                middleware: web,
                permissions: ['company-projects:create'],
                title: " ایجاد پروژه  "
            }
        },
        {
            path: "groups",
            name: "company.groups",
            component: groupIndex,
            meta: {
                middleware: web,
                permissions: ['company-groups:viewAny'],
                title: "گروه شرکت ها"
            }
        },
        {
            path: "places",
            name: "company.places",
            component: placeIndex,
            meta: {
                middleware: web,
                permissions: ['company-places:viewAny'],
                title: "محل استقرار"
            }
        },
        {
            path: "fields",
            name: "company.filed",
            component: filedIndex,
            meta: {
                middleware: web,
                permissions: ['company-fields:viewAny'],
                title: "حوزه فعالیت"
            }
        },
        {
            path: "list/:id/news",
            name: "company.news",
            component: newsIndex,
            meta: {
                middleware: web,
                permissions: ['company-news:viewAny'],
                title: "اخبار شرکت"
            }
        },
        {
            path: "list/news/:id",
            name: "company.news.edit",
            component: newsEdit,
            meta: {
                middleware: web,
                permissions: ['company-news:update','company-news:view'],
                title: " جزئیات اخبار"
            }
        },
        {
            path: "list/:id/news/create",
            name: "company.news.create",
            component: newsCreate,
            meta: {
                middleware: web,
                permissions: ['company-news:create'],
                title: " ایجاد خبر"
            }
        },
        {
            path: "list/:id/panel",
            name: "company.panel",
            component: panelIndex,
            meta: {
                middleware: web,
                permissions: ['company-changes:viewAny', 'companies:panel'],
                title: "پنل شرکت‌ها"
            }
        },
    ])
]